(function () {
  if (window.__etCartProgressInit) return;
  window.__etCartProgressInit = true;

  var busy = false;
  var lastCartTotal = -1;
  var dropdownBound = false;
  var lastBarInstance = null;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var bar = document.getElementById('EtCartProgress');
    var format = bar ? bar.dataset.moneyFormat : null;
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    if (format) {
      return format.replace('{{amount}}', amount).replace('{{amount_with_comma_separator}}', amount);
    }
    return '€' + amount;
  }

  function getConfig() {
    var bar = document.getElementById('EtCartProgress');
    if (!bar) return null;
    if (bar.closest('template')) return null;

    var configEl = document.getElementById('EtCartProgressConfig');
    var products = [];
    if (configEl) {
      try {
        products = JSON.parse(configEl.textContent);
      } catch (e) {}
    }

    return {
      bar: bar,
      shippingThreshold: parseInt(bar.dataset.shippingThreshold, 10) || 0,
      giftThreshold: parseInt(bar.dataset.giftThreshold, 10) || 0,
      giftProducts: products,
      msgBeforeShipping: bar.dataset.msgBeforeShipping || '',
      msgBeforeGift: bar.dataset.msgBeforeGift || '',
      msgComplete: bar.dataset.msgComplete || '',
      giftSelectLabel: bar.dataset.giftSelectLabel || 'Free Gift'
    };
  }

  function getCartTotalWithoutGift(cart) {
    var total = cart.total_price;
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties;
      if (props && props._is_free_gift) {
        total -= cart.items[i].final_line_price;
      }
    }
    return Math.max(0, total);
  }

  function findGiftItem(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties;
      if (props && props._is_free_gift) {
        return cart.items[i];
      }
    }
    return null;
  }

  function updateBarDOM(cfg, totalWithoutGift) {
    var bar = cfg.bar;
    var shippingReached = cfg.shippingThreshold > 0 && totalWithoutGift >= cfg.shippingThreshold;
    var giftReached = cfg.giftThreshold > 0 && totalWithoutGift >= cfg.giftThreshold;

    var shippingPct = 0;
    if (cfg.shippingThreshold > 0) {
      shippingPct = Math.min(100, (totalWithoutGift / cfg.shippingThreshold) * 100);
    }

    var giftPct = 0;
    if (cfg.giftThreshold > 0 && shippingReached) {
      var giftRange = cfg.giftThreshold - cfg.shippingThreshold;
      if (giftRange > 0) {
        var giftProgress = totalWithoutGift - cfg.shippingThreshold;
        giftPct = Math.min(100, Math.max(0, (giftProgress / giftRange) * 100));
      }
    }

    var fillShipping = bar.querySelector('[data-fill-shipping]');
    var fillGift = bar.querySelector('[data-fill-gift]');
    if (fillShipping) fillShipping.style.width = shippingPct + '%';
    if (fillGift) fillGift.style.width = giftPct + '%';

    var milestoneShipping = bar.querySelector('[data-milestone-shipping]');
    var milestoneGift = bar.querySelector('[data-milestone-gift]');
    if (milestoneShipping) {
      milestoneShipping.classList.toggle('et-gift-bar__milestone--active', shippingReached);
    }
    if (milestoneGift) {
      milestoneGift.classList.toggle('et-gift-bar__milestone--active', giftReached);
    }

    bar.classList.toggle('et-gift-bar--gift-reached', giftReached);

    var labelShipping = bar.querySelector('[data-label-shipping]');
    var labelGift = bar.querySelector('[data-label-gift]');
    if (labelShipping) {
      labelShipping.classList.toggle('et-gift-bar__label--active', shippingReached);
    }
    if (labelGift) {
      labelGift.classList.toggle('et-gift-bar__label--active', giftReached);
    }

    var messageEl = bar.querySelector('[data-message]');
    if (messageEl) {
      if (!shippingReached) {
        var remaining = Math.max(0, cfg.shippingThreshold - totalWithoutGift);
        messageEl.textContent = cfg.msgBeforeShipping.replace('%amount%', formatMoney(remaining));
      } else if (!giftReached && cfg.giftThreshold > 0) {
        var remaining = Math.max(0, cfg.giftThreshold - totalWithoutGift);
        messageEl.textContent = cfg.msgBeforeGift.replace('%amount%', formatMoney(remaining));
      } else {
        messageEl.textContent = cfg.msgComplete;
      }
    }
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('reload-side-cart'));
  }

  function addGift(variantId, callback) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _is_free_gift: 'true' } }]
      })
    })
      .then(function () {
        if (callback) callback();
      })
      .catch(function () {
        if (callback) callback();
      });
  }

  function removeGift(lineKey, callback) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () {
        if (callback) callback();
      })
      .catch(function () {
        if (callback) callback();
      });
  }

  function updateSelectedGiftUI(cfg, variantId) {
    var bar = cfg.bar;
    for (var i = 0; i < cfg.giftProducts.length; i++) {
      var p = cfg.giftProducts[i];
      if (p.variantId === variantId) {
        var imgEl = bar.querySelector('[data-gift-selected-image]');
        var titleEl = bar.querySelector('[data-gift-selected-title]');
        var priceEl = bar.querySelector('[data-gift-selected-price]');

        if (imgEl) {
          if (p.image) {
            imgEl.src = p.image;
            imgEl.alt = p.title;
            imgEl.style.display = '';
          } else {
            imgEl.style.display = 'none';
          }
        }
        if (titleEl) titleEl.textContent = p.title;
        if (priceEl) priceEl.textContent = p.priceFormatted;
        break;
      }
    }
  }

  function initDropdown(cfg) {
    var bar = cfg.bar;
    var toggle = bar.querySelector('[data-gift-toggle]');
    var dropdown = bar.querySelector('[data-gift-dropdown]');
    if (!toggle || !dropdown) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('et-gift-bar__gift-dropdown--open');
      if (isOpen) {
        dropdown.classList.remove('et-gift-bar__gift-dropdown--open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.classList.add('et-gift-bar__gift-dropdown--open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.classList.remove('et-gift-bar__gift-dropdown--open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    var options = bar.querySelectorAll('[data-gift-option]');
    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function () {
        if (busy) return;
        busy = true;

        var newVariantId = parseInt(this.getAttribute('data-variant-id'), 10);
        dropdown.classList.remove('et-gift-bar__gift-dropdown--open');
        toggle.setAttribute('aria-expanded', 'false');

        updateSelectedGiftUI(cfg, newVariantId);

        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var existingGift = findGiftItem(cart);
            if (existingGift) {
              return removeGift(existingGift.key, function () {
                addGift(newVariantId, function () {
                  lastCartTotal = -1;
                  busy = false;
                  refreshCartDrawer();
                });
              });
            } else {
              return addGift(newVariantId, function () {
                lastCartTotal = -1;
                busy = false;
                refreshCartDrawer();
              });
            }
          })
          .catch(function () {
            busy = false;
          });
      });
    }
  }

  function tryInitDropdown() {
    var cfg = getConfig();
    if (!cfg) {
      dropdownBound = false;
      lastBarInstance = null;
      return;
    }
    if (cfg.bar !== lastBarInstance) {
      dropdownBound = false;
      lastBarInstance = cfg.bar;
    }
    if (!dropdownBound) {
      initDropdown(cfg);
      dropdownBound = true;
    }
  }

  function pollCart() {
    if (busy) return;

    var cfg = getConfig();
    if (!cfg) return;

    tryInitDropdown();

    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalWithoutGift = getCartTotalWithoutGift(cart);

        updateBarDOM(cfg, totalWithoutGift);

        if (totalWithoutGift === lastCartTotal) return;
        lastCartTotal = totalWithoutGift;

        var giftReached = cfg.giftThreshold > 0 && totalWithoutGift >= cfg.giftThreshold;
        var giftItem = findGiftItem(cart);

        if (giftReached && !giftItem && cfg.giftProducts.length > 0) {
          var firstVariant = cfg.giftProducts[0].variantId;
          updateSelectedGiftUI(cfg, firstVariant);
          return addGift(firstVariant, function () {
            lastCartTotal = -1;
            refreshCartDrawer();
          });
        } else if (!giftReached && giftItem) {
          return removeGift(giftItem.key, function () {
            lastCartTotal = -1;
            refreshCartDrawer();
          });
        } else if (giftReached && giftItem) {
          updateSelectedGiftUI(cfg, giftItem.variant_id);
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  setInterval(pollCart, 1000);
  pollCart();
})();
